import React from 'react';
import './Subtotal.css';
import CurrencyFormat from 'react-currency-format';
import { useStateValue } from '../StateProvider/StateProvider';
import { getSelectedItemsTotal } from '../StateProvider/reducer';
import { Link } from 'react-router-dom';

function Subtotal() {
  const [{ user, selectedCartItems, totalSelectedCartItems }] = useStateValue();

  const proceedToCheckout = () => {
    if (user === null) sessionStorage['returnURL'] = '/payment';
  };

  return (
    <div className="subtotal">
      {selectedCartItems.length > 0 ? (
        <CurrencyFormat
          renderText={(value) => (
            <>
              <p>
                Subtotal ({totalSelectedCartItems} item
                {totalSelectedCartItems > 1 ? 's' : ''}
                ): <strong>{value}</strong>
              </p>
              <div className="subtotal__gift">
                <div className="subtotal__checkboxContainer">
                  <input className="subtotal__checkbox" type="checkbox" />
                  <span className="subtotal__checkmark"></span>
                </div>
                <small>This order contains a gift</small>
              </div>
            </>
          )}
          decimalScale={2}
          fixedDecimalScale={true}
          value={getSelectedItemsTotal(selectedCartItems)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
        />
      ) : (
        <p>No Price</p>
      )}
      {totalSelectedCartItems > 0 ? (
        <Link to={user ? '/payment' : '/login'}>
          <button
            className="app__button"
            onClick={proceedToCheckout}
            disabled={totalSelectedCartItems < 1}
          >
            Proceed to Checkout
          </button>
        </Link>
      ) : null}
    </div>
  );
}

export default Subtotal;
